import React from 'react';
import PropTypes from 'prop-types';

class ToggleButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isToggled: props.isToggled,
            xhrUrl: props.xhrUrl,
        };

        this.handleToggle = this.handleToggle.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.xhrUrl === prevState.xhrUrl) return null;

        return {
            isToggled: nextProps.isToggled,
            xhrUrl: nextProps.xhrUrl,
        };
    }

    componentWillUnmount() {
        this.abortRequest();
    }

    abortRequest() {
        if (this.request) {
            this.request.abort();
        }
    }

    save() {
        this.abortRequest();
        this.request = this.props.toggleRequest(this.state.isToggled, this.state.xhrUrl);
        this.request.catch(() => {
            this.setState((state) => ({
                isToggled: !state.isToggled,
            }));
        });
    }

    handleToggle() {
        this.setState(
            (state) => ({
                isToggled: !state.isToggled,
            }),
            this.save
        );
    }

    render() {
        return this.props.render({
            isToggled: this.state.isToggled,
            onToggle: this.handleToggle,
        });
    }
}

ToggleButton.propTypes = {
    xhrUrl: PropTypes.string.isRequired,
    isToggled: PropTypes.bool.isRequired,
    render: PropTypes.func.isRequired,
    toggleRequest: PropTypes.func.isRequired,
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/web/js/browse/components/toggle-button.jsx